<template>
	<div class="job-bot">
		<JonMessages :messages="messages"/>
		<div class="button-container">
			<Button
				text="Los geht's"
				icon="checkmark"
				:style="{'animation-delay': (messages.length) + 's'}"
				@click="start"
			/>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import {mapActions} from "vuex";
import Jon from "@/vue/common/image/Jon.vue";
import JonMessages from "@/vue/customer-area/job-profile/JonMessages.vue";

export default {

	components: {
		JonMessages,
		Jon,
		Button,
	},

	props: {
		jobProfile: {
			type: Object,
			required: true,
		},
		isInitial: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	computed: {
		messages ()
		{
			let messages = [
				'Sag mir noch mehr über den Job, damit ich dir wirklich passende Kandidaten anzeigen kann.'
			];

			if (this.isInitial)
			{
				messages.unshift('Schön, dass du hier bist!',)
			}

			return messages;
		}
	},

	methods: {
		...mapActions('jobProfile/questionnaire', [
			'show'
		]),
		start ()
		{
			this.show({
				jobProfile: this.jobProfile,
				onClose: data =>
				{
					this.$emit('close', data);
				},
			});
		},
	},
}
</script>
